export default __webpack_public_path__ + "static/media/gallery_01.a8d804fb.jpg";